import React from 'react';
import Button from './../../components/button/button';

const DateSelector = ({ selectedView, showDateButtons, displayDateName, filteredViewData, handleButtonClick, handleSelect, selectedDate }) => {

  const seasonIcons = {
    Hiver: 'picto-winter',
    Eté: 'picto-summer',
    Equinox: 'picto-rain',
  };

  return (
    <div id="dateSelector" className="buttonContainerDate">
      <div className="buttonContainerMainDate">
        <Button
          customClass={displayDateName ? 'btnDate' : 'btnDate'}
          onClick={() => handleButtonClick('date')}
          text={displayDateName ? displayDateName : 'Eté'}
          icon={displayDateName ? seasonIcons[displayDateName] : seasonIcons['Eté']}
        />
      </div>
      {showDateButtons &&
        filteredViewData.map((view) => {
          const seasonKeys = Object.keys(view.seasons);
          return (
            <div className='buttonContainerDisplayDate' key={view.id}>
              {seasonKeys.map((seasonName) => {
                const season = view.seasons[seasonName];
                return (
                  <Button
                    key={seasonName}
                    onClick={() => handleSelect(seasonName, 'date', season.displayName)}
                    text={season.displayName}
                    customClass={seasonName === selectedDate ? 'pdvGrayed' : 'pdvNormal'}
                    icon={seasonIcons[season.displayName]}
                  />
                );
              })}
            </div>
          );
        })}
      {!selectedView && showDateButtons && (
        <div className='errorMessage'>
          Sélectionnez d'abord un "Point de vue".
        </div>
      )}
    </div>
  );
};

export default DateSelector;